// Normaliza imagens vindas como string ou como objeto do Cloudinary.
export function getImageUrl(image) {
  if (!image) return null;
  if (typeof image === "string") return image;
  return image.url || null;
}

const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export function getYoutubeThumbnailUrl(value) {
  const url = getImageUrl(value);
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const pathParts = parsedUrl.pathname.split("/").filter(Boolean);
    const videoId = parsedUrl.searchParams.get("v") ||
      (["embed", "shorts", "live"].includes(pathParts[0])
        ? pathParts[1]
        : parsedUrl.hostname.replace(/^www\./, "") === "youtu.be"
          ? pathParts[0]
          : null);

    return YOUTUBE_VIDEO_ID_PATTERN.test(videoId || "")
      ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
      : null;
  } catch {
    return null;
  }
}

function getYoutubeEmbedUrl(videoId) {
  if (!YOUTUBE_VIDEO_ID_PATTERN.test(videoId || "")) return null;
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
}

export function getVideoEmbedUrl(media) {
  const url = getImageUrl(media);
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.hostname.replace(/^www\./, "").toLowerCase();

    if (host === "youtu.be") {
      const videoId = parsedUrl.pathname.split("/").filter(Boolean)[0];
      return getYoutubeEmbedUrl(videoId);
    }

    if (
      host === "youtube.com" ||
      host === "m.youtube.com" ||
      host === "youtube-nocookie.com"
    ) {
      const pathParts = parsedUrl.pathname.split("/").filter(Boolean);
      const videoId =
        parsedUrl.searchParams.get("v") ||
        (["embed", "shorts", "live"].includes(pathParts[0])
          ? pathParts[1]
          : null);
      return getYoutubeEmbedUrl(videoId);
    }

    if (host === "instagram.com") {
      const pathParts = parsedUrl.pathname.split("/").filter(Boolean);
      if (["p", "reel", "tv"].includes(pathParts[0]) && pathParts[1]) {
        return `https://www.instagram.com/${pathParts[0]}/${pathParts[1]}/embed`;
      }
    }
  } catch {
    return null;
  }

  return null;
}

export function isSupportedVideoUrl(value) {
  return Boolean(getVideoEmbedUrl(value));
}
